import React, { useEffect, useMemo, useState } from 'react';
import Alert from '../components/utils/Alert';
import StatsCard from '../components/StatsCard/StatsCard';
import Container from "react-bootstrap/Container";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import moment from "moment";
import Chart from "react-apexcharts";
// import Loader from "../components/utils/Loader";


const Dashboard = () => {
  const [selectPeriod, setSelectPeriod] = useState('currentWeek')
  const [selectdPeriodList, setSelectdPeriodList] = useState('currentWeek')
  const [loading, setLoading] = useState(true);
  const predefinedPeriods = {
    currentWeek: moment().startOf("week").toDate(),
    lastWeek: moment().subtract(1, "week").startOf("week").toDate(),
    thisMonth: moment().startOf("month").toDate(),
    thisYear: moment().startOf("year").toDate(),
  };

  const options = [
    { key: "currentWeek", label: "Current Week" },
    { key: "lastWeek", label: "Last Week" },
    { key: "thisMonth", label: "This Month" },
    { key: "thisYear", label: "This Year" },
  ];


  const statsCardData = [
    {
      id: 1,
      counter: 8976,
      bgColor: '#5c6bc0',
      symbol: '',
      symbolPosition: 'right',
      isCounter: true,
      title: 'Activation',
      progressPercent: 25,
      description: 'Total number of activated services.',
    },
    {
      id: 2,
      counter: 628,
      bgColor: '#ffa726',
      symbol: '',
      symbolPosition: '',
      isCounter: true,
      title: 'Recharge',
      progressPercent: 25,
      description: 'Total number of recharge transactions completed.',
    },
    {
      id: 3,
      counter: 5812,
      bgColor: '#ef5350',
      symbol: '',
      symbolPosition: 'left',
      isCounter: true,
      title: 'Inventory Status',
      progressPercent: 25,
      description: 'Current stock availability across all items.',
    },
    {
      id: 4,
      counter: 578,
      bgColor: '#42a5f5',
      symbol: '$',
      symbolPosition: 'left',
      isCounter: true,
      title: 'Profit',
      progressPercent: 25,
      description: 'Total profit generated from sales and services.',
    }
  ];

  const changeDateHandler = (item) => {
    setSelectPeriod(item.key)
    setSelectdPeriodList(getDateCategories(item.key))
    console.log("getDateCategories(selectPeriod)==>>",)
    const formattedDate = moment(predefinedPeriods[item.key]).format("YYYY-MM-DD");
    const currentDate = moment().format("YYYY-MM-DD");
    const apiData = {
      fromDate: formattedDate,
      toDate: currentDate,
      actionType: ""
    }
    console.log("apiData==>>", apiData)
    // dispatch(getReport(apiData))
  }

  const donutOptions = (title) => ({
    chart: { type: "donut" },
    labels: ["Success", "Pending", "Fail"],
    colors: ["#008ffb", "#53b3fc", "#8accfd"],
    //  colors: ["#28a745", "#dc3545", "#ffc107"],
    legend: { position: "bottom" },
    // title: { text: title, align: "center" },
  });

  useEffect(() => {
    setLoading(true);

    setTimeout(() => {
      setLoading(false);
    }, 3000);
  }, []);

  const getDateCategories = (type) => {
    const now = new Date();

    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    let labels = [];

    switch (type) {

      // Current Week (Mon → Sun)
      case "currentWeek": {
        const day = now.getDay();
        const monday = new Date(now);
        monday.setDate(now.getDate() - day + (day === 0 ? -6 : 1));

        for (let i = 0; i < 7; i++) {
          const d = new Date(monday);
          d.setDate(monday.getDate() + i);
          labels.push(d.toLocaleDateString("en-US", { weekday: "short" }));
        }
        break;
      }

      // Last Week → Day wise
      case "lastWeek": {
        const day = now.getDay();
        const lastMonday = new Date(now);
        lastMonday.setDate(now.getDate() - day - 6);

        for (let i = 0; i < 7; i++) {
          const d = new Date(lastMonday);
          d.setDate(lastMonday.getDate() + i);
          labels.push(d.toLocaleDateString("en-US", { weekday: "short" }));
        }
        break;
      }

      // This Month → Week wise
      case "thisMonth": {
        const year = now.getFullYear();
        const month = now.getMonth();
        const totalDays = new Date(year, month + 1, 0).getDate();
        const weeks = Math.ceil(totalDays / 7);

        for (let i = 1; i <= weeks; i++) {
          labels.push(`Week ${i}`);
        }

        break;
      }

      // This Year → Month wise
      case "thisYear": {
        let d = new Date();
        d.setDate(1);

        for (let i = 0; i < 12; i++) {
          labels.unshift(
            `${monthNames[d.getMonth()]} ${d.getFullYear()}`
          );
          d.setMonth(d.getMonth() - 1);
        }
        break;
      }

      default:
        return [];
    }

    return labels;
  };


  const generateSeriesData = (length) => {
    return Array.from({ length }, () =>
      Math.floor(Math.random() * 1000) + 100
    );
  };

  const commissionCategories = useMemo(() => {
    return getDateCategories(selectPeriod);
  }, [selectPeriod]);


  const commissionSeries = useMemo(() => {
    return [
      {
        name: "Commission",
        data: generateSeriesData(commissionCategories.length),
      },
    ];
  }, [commissionCategories]);


  const lineOptions = {
    chart: {
      type: "line",
      toolbar: { show: false },
    },
    stroke: {
      curve: "smooth",
      width: 3,
    },
    colors: ["#8e0e9d"],
    xaxis: {
      categories: commissionCategories,
    },
    yaxis: {
      labels: {
        formatter: (val) => `$${val}`,
      },
    },
    tooltip: {
      y: {
        formatter: (val) => `$${val}`,
      },
    },
  };

  // Activation
  const activationSeries = [7000, 1500, 800,];

  // Recharge
  const rechargeSeries = [8000, 2500, 1200,];



  return (
    <>
      {/* <Loader/> */}
      <Container fluid className="p-0">

        {/* Tenure Tabs */}
        <div className="mb-3">

          {/* Buttons */}
          <div className="d-flex gap-3 flex-wrap">
            {/* <div
              className="col-md-1 d-flex justify-content-center align-items-center p-2"
              style={{ backgroundColor: '#e2e2e2', color: '#7e5084' }}
            >
              <h6 className="m-0"><i className="ri-timer-line"></i>Tenure</h6>
            </div> */}
            {options.map((item) => (
              <div
                key={item.key}
                onClick={() => changeDateHandler(item)}
                className="d-flex align-items-center px-3 py-2 rounded border"
                style={{
                  cursor: "pointer",
                  minWidth: "170px",
                  justifyContent: "space-between",
                  background:
                    selectPeriod === item.key
                      ? "linear-gradient(90deg, #8e0e9d, #8e0e9d)"
                      : "#fff",
                  color: selectPeriod === item.key ? "#fff" : "#000",
                  borderColor: selectPeriod === item.key ? "transparent" : "#dee2e6",
                }}
              >
                <div className="d-flex align-items-center gap-2">
                  <i className="ri-calendar-line"></i>
                  <span style={{ fontWeight: "500", fontSize: "14px" }}>{item.label}</span>
                </div>

                {item.isDefault && selectPeriod === item.key && (
                  <span className="badge bg-light text-primary ms-2">
                    Default
                  </span>
                )}
              </div>
            ))}
          </div>

        </div>

        {/* start revenue section */}
        <Row className="gy-4 gx-4 mb-4">
          {statsCardData.map((cardItem) => (
            <Col key={cardItem?.id} sm={12} md={6} lg={3} xl={3}>
              <StatsCard
                type="revenue-progressBar"
                bgColor={cardItem?.bgColor}
                symbol={cardItem?.symbol}
                symbolPosition={cardItem?.symbolPosition}
                counter={cardItem?.counter}
                isCounter={cardItem?.isCounter}
                title={cardItem?.title}
                progressPercent={cardItem?.progressPercent}
                description={cardItem?.description}
              />
            </Col>
          ))}
        </Row>
        {/* end revenue section */}

        {/* Grap cards*/}
        <div className="row g-3">
          {/* Activation */}
          <div className="col-md-4 d-flex">
            <div className="p-3 w-100 h-100" style={{ backgroundColor: '#fff' }}>
              <div className="card-body d-flex flex-column">
                <h6 className="r"><i className="ri-checkbox-circle-line me-2"></i>Activation</h6>
                <div className="flex-grow-1 d-flex align-items-center justify-content-center">
                  <Chart
                    options={donutOptions("Activation")}
                    series={activationSeries}
                    type="donut"
                    height={300}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Recharge */}
          <div className="col-md-4 d-flex">
            <div className="p-3 w-100 h-100" style={{ backgroundColor: '#fff' }}>
              <div className="card-body d-flex flex-column">
                <h6 className=""><i className="ri-flashlight-line me-2"></i>Recharge</h6>

                <div className="flex-grow-1 d-flex align-items-center justify-content-center">
                  <Chart
                    options={donutOptions("Recharge")}
                    series={rechargeSeries}
                    type="donut"
                    height={300}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Commission */}
          <div className="col-md-4 d-flex">
            <div className="p-3 w-100 h-100" style={{ backgroundColor: '#fff' }}>
              <div className="card-body d-flex flex-column">

                {/* Title */}
                <h6 className="mb-3">
                  <i className="ri-stack-line me-2"></i>
                  Commission
                </h6>

                {/* Chart Container */}
                <div className="flex-grow-1">
                  <Chart
                    options={lineOptions}
                    series={commissionSeries}
                    type="line"
                    height={270}   // ✅ fill remaining space
                    width="100%"    // ✅ full width
                  />
                </div>

              </div>
            </div>
          </div>

        </div>

      </Container>
    </>
  )
}

export default Dashboard
